import React, { memo, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { Button } from '@mui/material';
import { ModalSize } from '@sharedCR/coreDesignSystem/Modals';
import Iframe from 'app/shared/components/common/Iframe';
import { isNull, isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import { openDialogAction, showMessageAction } from 'store/global/actions';
import { getOptimalBlueLaunchUrlAction } from 'store/pricing/actions';

import { PropertyAndLoanTestIds } from '../../../../PropertyAndLoan.testIds';

import {
  LaunchUiDialogSize,
  OptimalBlueLaunchButtonText,
} from './OptimalBlueLaunchButton.constants';

const OptimalBlueLaunchButton = ({ isHidden = false }) => {
  const dispatch = useDispatch();
  const { applicationId } = useParams();

  const [isLoading, setIsLoading] = useState(false);

  const onLaunchOptimalBlue = useCallback(async () => {
    setIsLoading(true);
    const launchUrl = await dispatch(getOptimalBlueLaunchUrlAction({ applicationId }));
    setIsLoading(false);

    // undefined => the request failed and catchAsyncActionError already surfaced the error.
    if (isUndefined(launchUrl)) {
      return;
    }

    // null => Launch UI is disabled for the company (server gate).
    if (isNull(launchUrl)) {
      dispatch(
        showMessageAction({ message: OptimalBlueLaunchButtonText.NOT_ENABLED, variant: 'info' }),
      );

      return;
    }

    dispatch(
      openDialogAction({
        header: OptimalBlueLaunchButtonText.DIALOG_HEADER,
        size: ModalSize.XL,
        body: () => (
          <Iframe
            height={LaunchUiDialogSize.HEIGHT}
            src={launchUrl}
            title={OptimalBlueLaunchButtonText.DIALOG_HEADER}
            width={LaunchUiDialogSize.WIDTH}
          />
        ),
      }),
    );
  }, [dispatch, applicationId]);

  if (isHidden) {
    return null;
  }

  return (
    <Button
      data-testid={PropertyAndLoanTestIds.OPTIMAL_BLUE_LAUNCH_BUTTON}
      disabled={isLoading}
      variant="outlined"
      onClick={onLaunchOptimalBlue}
    >
      {OptimalBlueLaunchButtonText.BUTTON}
    </Button>
  );
};

OptimalBlueLaunchButton.propTypes = {
  isHidden: PropTypes.bool,
};

export default memo(OptimalBlueLaunchButton);
